module.exports = __webpack_public_path__ + "static/media/snowy.67d63a14.svg";